import React from 'react';
import NavTabs from 'components/NavTabs/NavTabs';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';

import Zones from './ZonesList/index';
import ZonesAutomaticUpdate from './ZonesAutomaticUpdate/ZonesAutomaticUpdate';

const useStyles = makeStyles(() => ({
  customTabs: {
    marginTop: '24px',
    marginBottom: '8px',
  },
}));

const Zone = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <DataGridStateContextProvider>
      <NavTabs
        classes={{ tabs: classes.customTabs }}
        tabs={[
          {
            tabButton: t('zonesAutomaticUpdate.zoneListTab'),
            tabContent: <Zones />,
          },
          {
            tabButton: t('zonesAutomaticUpdate.autoUpdateTab'),
            tabContent: <ZonesAutomaticUpdate />,
          },
        ]}
      />
    </DataGridStateContextProvider>
  );
};

export default Zone;
